// The chart and handler currently driving the header symbol. TradingView's
// subscribe() returns nothing, so these are what unsubscribe() needs.
let bound: { chart: any; handler: () => void } | null = null;

export function subscribeToActiveChartSymbol(tvWidgetChart: any, datafeed: any) {
    // 1. Cleanup old subscription
    if (bound) {
        try {
            bound.chart.onSymbolChanged().unsubscribe(null, bound.handler);
        } catch (e) { /* the chart is already gone */ }
        bound = null;
    }

    const chart = tvWidgetChart.activeChart();
    const handler = () => datafeed.setHeaderSymbol(chart.symbol());

    // 2. Subscribe to new active chart
    chart.onSymbolChanged().subscribe(null, handler);
    bound = { chart, handler };

    // 3. Sync immediately
    datafeed.setHeaderSymbol(chart.symbol());
};
